export const VOTE_STATUS_CONFIG = [
  {
    label: 'Đồng ý',
    color: 'green',
    value: true,
  },
  {
    label: 'Không đồng ý',
    color: 'red',
    value: false,
  },
  {
    label: 'Chưa cho ý kiến',
    color: 'gold',
    value: null,
  },
]
